import { Component, OnInit } from '@angular/core';

import { Meta } from '@angular/platform-browser';
import { MatSnackBar } from '@angular/material';
import 'hammerjs';
import {CommonService } from '../../services/common.service';
import { NgForm } from '@angular/forms';
import { FormBuilder, Validators, FormGroup, ValidatorFn, AbstractControl, FormControl } from '@angular/forms';
import { Router } from '@angular/router';
import { MatDialog, MatDialogRef } from '@angular/material';
import { PermissionComponent } from "../permission/permission.component";
import { ProductsService } from '../../services/products.service';
@Component({
  selector: 'app-nestmain',
  templateUrl: './nestmain.component.html',
  styleUrls: ['./nestmain.component.css']
})
export class NestmainComponent implements OnInit {
  loading: any;
  staticdata: any;
  role_id= 2;
  dob= '00/00/0000';
  action: any;
  remember_token= '1';
  image= 'avatar-1577909_960_720.png';
  show= false;
  msg = '';
  registrationform: any;
  em: any;
  ipadd = '0.0.0.0';
  source: any;
  redirecrcheckflag: number;

  tempcartdata: any;
  currentusercartdata: any;
  temparray = [];
  temcartdatalength: any;
  typeofpets: any;



  constructor(private productService: ProductsService, private meta: Meta,
    private commonService: CommonService, public form: FormBuilder,private snackbar: MatSnackBar,
    private router: Router, public dialog: MatDialog, private commonSerive: CommonService) {
      this.commonSerive.setNestMenuFlag(1);
    const title = this.meta.getTag('name=title');
    this.meta.removeTagElement(title);
    const description = this.meta.getTag('name=description');
    this.meta.removeTagElement(description);
    this.meta.addTag({ name: 'title', content: 'Pet resort with Kennels, Swimming Pool & more' });
    this.meta.addTag({ name: 'description', content: 'Pet Boarding, Grooming, Training & Daycare for dogs & cats | Dog Park | Grooming | Leash Free | Trained Staff | CCTV Facility' });

    this.source = 'WebApp';

    this.registrationform = this.form.group({
      'name': new FormControl('', Validators.required),
      'email': new FormControl('', [Validators.required,
        Validators.pattern(/^[a-z0-9!#$%&'*+\/=?^_`{|}~.-]+@[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z0-9]([a-z0-9-]*[a-z0-9])?)*$/i)]),
      'mobile': new FormControl('', [Validators.required, Validators.minLength(10)]),
      'noofpets': new FormControl('' , [Validators.required]),
      'typeofpets': new FormControl ('' , [Validators.required])


      });
    }

  ngOnInit() {
  }





 doSignup() {
  this.loading = true;

  this.commonService.postpromoform(this.registrationform.name, this.registrationform.email, this.registrationform.mobile,
    this.registrationform.noofpets, this.typeofpets, this.source)
  .subscribe(result => {
    this.msg = 'Thank you for registering for updates. You will be hearing from us soon!';
    this.openSnackBar();
    this.loading = false;
    const dialogRef = this.dialog.open(PermissionComponent , {
      width: '400px',
      height: '400px',
      data: {}
    });
    dialogRef.afterClosed().subscribe(() => {
      this.router.navigate(['/store/home']);
    });
  }, (err) => {


  });

  }

  openSnackBar() {
   this.snackbar.open(this.msg , this.action, {
     duration: 3000,
   });
 }

 bookNest() {
  const flag = 9;
  this.commonService.setActivatepath(flag);
   this.router.navigate(['/nest/booking']);
}


}
